import React from "react";
import "./Shimmer.scss";

const Shimmer = () => {
  return (
    <div className="shimmer-container">
      <div className="shimmer-header">
        <div className="shimmer-box small"></div>
        <div className="shimmer-box medium"></div>
        <div className="shimmer-box large"></div>
      </div>
      <div className="shimmer-header-2">
        <div className="shimmer-box small"></div>
        <div className="shimmer-box medium"></div>
      </div>

      <div className="shimmer-content">
        <div className="shimmer-row first-row">
          <div className="shimmer-box full"></div>
          <div className="shimmer-box half"></div>
          <div className="shimmer-box large"></div>
        </div>
        <div className="shimmer-row">
          {/* <div className="shimmer-box full"></div> */}
          <div className="shimmer-box large"></div>
          <div className="shimmer-box third"></div>

          <div className="shimmer-box full"></div>
        </div>

        <div className="shimmer-card-container">
          <div className="shimmer-card-container-row">
            <div className="shimmner-ard-data">
              <div className="shimmer-card-container-row-data one"></div>
              <div className="shimmer-card-container-row-data two"></div>
              <div className="shimmer-card-container-row-data third"></div>
            </div>
            <div className="shimmer-card"></div>
          </div>

          <div className="shimmer-card-container-row">
            <div className="shimmner-ard-data">
              <div className="shimmer-card-container-row-data one"></div>
              <div className="shimmer-card-container-row-data two"></div>
              <div className="shimmer-card-container-row-data third"></div>
            </div>
            <div className="shimmer-card"></div>
          </div>

          <div className="shimmer-card-container-row">
            <div className="shimmner-ard-data">
              <div className="shimmer-card-container-row-data one"></div>
              <div className="shimmer-card-container-row-data two"></div>
              <div className="shimmer-card-container-row-data third"></div>
            </div>
            <div className="shimmer-card"></div>
          </div>

          <div className="shimmer-card-container-row">
            <div className="shimmner-ard-data">
              <div className="shimmer-card-container-row-data one"></div>
              <div className="shimmer-card-container-row-data two"></div>
              <div className="shimmer-card-container-row-data third"></div>
            </div>
            <div className="shimmer-card"></div>
          </div>

          <div className="shimmer-card-container-row">
            <div className="shimmner-ard-data">
              <div className="shimmer-card-container-row-data one"></div>
              <div className="shimmer-card-container-row-data two"></div>
              <div className="shimmer-card-container-row-data third"></div>
            </div>
            <div className="shimmer-card"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Shimmer;
